import API from '@/lib/API.js'
import comun from './comun.js'
const beneficiarios = {
  namespaced: true,
  state: {
    Lista: [],
    Nuevo: undefined,
    Titular: undefined,
    Titulares: [],
    Seleccionado: undefined,
    GrupoFamiliar: [],
    TitularParaAltaFamiliares: undefined,
  },
  mutations: {
    init(state) {
      state.Lista = [];
      state.Nuevo = undefined;
      state.Titular = undefined;
      state.Titulares = [];
      state.Seleccionado = undefined;
      state.GrupoFamiliar = [];
    },
    set(state, datos) {
      state.Lista = datos;
    },
    setNuevo(state, datos) {
      state.Nuevo = datos;
    },
    setTitular(state, datos) {
      state.Titular = datos;
    },
    setTitulares(state, datos) {
      state.Titulares = datos;
    },
    setTitularParaAltaFamiliares(state, datos) {
      state.TitularParaAltaFamiliares = datos;
    },
    select(state, datos) {
      state.Seleccionado = datos;
    },
    selectGrupo(state, datos) {
      state.GrupoFamiliar = datos;
    },
  },
  actions: {
    async select({
      commit
    }, datos) {
      commit("comun/cargando")
      let data = [];
      if (datos) {
        let grupo = await API.Beneficiarios.traerPorAfi(datos.nro_afi)
        commit("selectGrupo", grupo)
      }
      commit("select", datos)
      commit("set", data)
      commit("comun/fincarga")
    },
    async selectTitular({
      commit,
      dispatch
    }, datos) {
      commit("comun/cargando")
      commit("setTitular", datos)
      await dispatch("TraerGrupoFamiliar", datos.nro_afi)
      commit("select", undefined)
      commit("comun/fincarga")
    },

    setTitularParaAltaFamiliares({
      commit
    }, datos) {
      commit("setTitularParaAltaFamiliares", datos)
    },
    async FiltrarBeneficiariosPorNombre({
      commit
    }, datos) {
      commit("comun/cargando")
      let data = await API.Beneficiarios.traerPorNombre(datos);
      commit("set", data)
      commit("select", undefined)
      commit("selectGrupo", [])
      commit("comun/fincarga")
    },
    async FiltrarTitularesPorNombre({
      commit
    }, datos) {
      commit("comun/cargando")
      let data = await API.Beneficiarios.traerTitularesPorNombre(datos);
      commit("setTitulares", data)
      commit("select", undefined)
      commit("comun/fincarga")
    },
    async FiltrarNuevoBeneficiarioDNI({
      commit
    }, datos) {
      commit("comun/cargando")
      let data = await API.Beneficiarios.traerPorDNI(datos);
      let sel = undefined;
      if (data.length === 0) {
        sel = API.Beneficiarios.Nuevo();
        sel.nro_doc = datos;
      } else {
        //sel = data[0]
        alert("Beneficiario existente")
      }
      commit("setNuevo", sel)
      commit("select", undefined)
      commit("comun/fincarga")
    },
    async FiltrarTitularesDNI({
      commit
    }, datos) {
      commit("comun/cargando")
      let data = await API.Beneficiarios.traerTitularesPorDNI(datos);
      commit("setTitulares", data)
      commit("select", undefined)
      commit("comun/fincarga")
    },
    async FiltrarBeneficiariosAfiyParent({
      commit
    }, datos) {
      commit("comun/cargando")
      let data = []
      if (datos.parent != '') {
        data = await API.Beneficiarios.traerPorAfiyParent(datos.nroafi, datos.parent);
      } else {
        data = await API.Beneficiarios.traerPorAfi(datos.nroafi);
      }
      commit("set", data)
      commit("select", undefined)
      commit("comun/fincarga")
    },
    async TraerGrupoFamiliar({
      commit
    }, datos) {
      commit("comun/cargando")
      let data = []
      data = await API.Beneficiarios.traerPorAfi(datos);
      commit("selectGrupo", data)
      commit("comun/fincarga")
      return 0;
    },
    setNuevo({
      commit
    }, data) {
      commit("setNuevo", data)
    },
    async FiltrarBeneficiariosDNI({
      commit
    }, datos) {
      commit("comun/cargando")
      let data = []
      data = await API.Beneficiarios.traerPorDNI(datos);
      let sel = undefined;
      if (data.length === 0) {
        sel = {
          nro_afi: datos,
          nro_doc: datos,
          id_afiliado: 0
        }
      }
      commit("set", data)
      commit("select", sel)
      commit("comun/fincarga")
    },
    async modificarBeneficiarioSeleccionado({
      commit,
      state,
      dispatch
    }) {
      try {
        let data = []
        if (state.Seleccionado.id_afiliado != 0) {
          data = await API.Beneficiarios.modificar(state.Seleccionado);
          commit("select", data)
          if (state.Seleccionado.parent = "00") {
            dispatch("TraerGrupoFamiliar", data.nro_afi)
          }
        } else {
          data = await API.Beneficiarios.alta(state.Seleccionado);
          commit("setNuevo", data)
        }
        commit("comun/mostrar", "Beneficiario Guardado")
      } catch (error) {
        alert(error)
      } finally {}
    },
    async modificarBeneficiario({
      commit,
      state
    }, entidad) {
      try {
        let data = []
        if (entidad.id_afiliado != 0) {
          data = await API.Beneficiarios.modificar(entidad);
        } else {
          data = await API.Beneficiarios.alta(entidad);
        }
        commit("comun/mostrar", "Beneficiario Guardado")
      } catch (error) {
        alert(error)
      } finally {}
    },
    async modificarNuevoBeneficiario({
      commit,
      dispatch,
      state
    }) {
      commit("comun/cargando")
      try {
        let data = {};
        if (state.Nuevo.id_afiliado != 0) {
          data = await API.Beneficiarios.modificar(state.Nuevo);
        } else {
          data = await API.Beneficiarios.alta(state.Nuevo);
        }
        await dispatch("TraerGrupoFamiliar", data.nro_afi)
        commit("setNuevo", data)
        commit("select", undefined)
      } catch (error) {
        alert(error)
      } finally {
        commit("comun/fincarga")
      }
    },
   
  },
  modules: {
    comun,
  }

}
export default beneficiarios;